import { Button } from '#/components/Button/Button';
import { H5 } from '#/components/Text/H5';
import { useI18n } from '#/i18n/hooks/useI18n';

import { SearchRefinementsHeaderHolder } from './SearchRefinementsHeader.styled';

type Props = {
  hasActiveRefinements?: boolean;
  onClickClearAll?: () => void;
};

export function SearchRefinementsHeader({
  hasActiveRefinements,
  onClickClearAll,
}: Props) {
  const { i18n } = useI18n();

  return (
    <SearchRefinementsHeaderHolder>
      {hasActiveRefinements ? (
        <Button
          qaId="clear-active-refinements"
          noPadding
          variant="tertiary"
          type="button"
          onClick={onClickClearAll}
        >
          {i18n('Clear Filters')}
        </Button>
      ) : (
        <H5 mb={0}>{i18n('Filters')}</H5>
      )}
    </SearchRefinementsHeaderHolder>
  );
}
